import { motion } from 'framer-motion'

interface RetakeFromReportCardProps {
  onRetake: () => void
}

export function RetakeFromReportCard({ onRetake }: RetakeFromReportCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="relative overflow-hidden rounded-2xl p-5 border border-orange-200/50"
    >
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50" />

      {/* Content */}
      <div className="relative z-10">
        <div className="flex items-start gap-4">
          {/* Camera icon */}
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-100 to-amber-100 flex items-center justify-center flex-shrink-0">
            <svg
              className="w-6 h-6 text-orange-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </div>

          {/* Text content */}
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 mb-1">
              Not happy with your results?
            </h3>
            <p className="text-sm text-gray-600 mb-3">
              You can take a new photo once for a fresh analysis.
            </p>

            {/* Retake button */}
            <button
              onClick={onRetake}
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-400 to-amber-400 text-white font-medium rounded-full text-sm shadow-md hover:shadow-lg transition-shadow active:scale-[0.98]"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              Take a New Photo
            </button>

            {/* Disclaimer */}
            <p className="text-xs text-gray-400 mt-2">
              One-time option - make sure you have good lighting!
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  )
}
